export default __webpack_public_path__ + "static/media/127.7072b16f.jpg";